// extracted by mini-css-extract-plugin
module.exports = {"userReportsList":"_1k758","userReport":"_2Av7F","userCard":"_3ukQk","userName":"_12C_1","redText":"_1zStI","checkbox":"_1TRRC"};